import React, { useState } from 'react';
import { FLORIDA_COUNTIES } from '../constants/states';

const CountyDropdown = ({ name, value, onChange, className, required }) => {
  const [isCustom, setIsCustom] = useState(false);
  const [customValue, setCustomValue] = useState('');

  // Check if current value is in the predefined list
  React.useEffect(() => {
    if (value && !FLORIDA_COUNTIES.includes(value)) {
      setIsCustom(true);
      setCustomValue(value);
    }
  }, [value]);

  // Handle county selection from dropdown
  const handleCountySelect = (e) => {
    const selectedValue = e.target.value;

    if (selectedValue === 'CUSTOM') {
      setIsCustom(true);
      setCustomValue('');
      // Create a synthetic event for the custom input
      const customEvent = {
        target: {
          name: name,
          value: ''
        }
      };
      onChange(customEvent);
    } else {
      setIsCustom(false);
      setCustomValue('');
      onChange(e);
    }
  };

  // Handle custom input change
  const handleCustomInput = (e) => {
    setCustomValue(e.target.value);
    // Pass the custom value to parent
    const customEvent = {
      target: {
        name: name,
        value: e.target.value
      }
    };
    onChange(customEvent);
  };

  return (
    <div>
      {!isCustom ? (
        <select
          name={name}
          value={value || ''}
          onChange={handleCountySelect}
          className={className}
          required={required}
        >
          <option value="">Select a county</option>
          {FLORIDA_COUNTIES.map((county) => (
            <option key={county} value={county}>
              {county}
            </option>
          ))}
          <option value="CUSTOM">--- Enter Custom County ---</option>
        </select>
      ) : (
        <div>
          <input
            type="text"
            name={name}
            value={customValue}
            onChange={handleCustomInput}
            className={className}
            placeholder="Enter county name"
            required={required}
          />
          <button
            type="button"
            onClick={() => {
              setIsCustom(false);
              setCustomValue('');
              const resetEvent = {
                target: {
                  name: name,
                  value: ''
                }
              };
              onChange(resetEvent);
            }}
            style={{
              marginLeft: '10px',
              padding: '5px 10px',
              backgroundColor: 'var(--primary-color)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            Back to List
          </button>
        </div>
      )}
    </div>
  );
};

export default CountyDropdown;
